import {
  Button,
  Dialog,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { handlePostUnit } from "../../../services/customerAreaManagement/customerUnit";
import { toast } from "material-react-toastify";
import { useStyles } from "./styles";

const CustomerDialog = (props) => {
  const [unitName, setUnitName] = useState();
  const customerId = useSelector((store) => store.auth.customer.customer);
  const classes = useStyles();

  const handleSetUnitName = (name) => {
    setUnitName(name);
  };

  const handleCreateUnit = async () => {
    if (!unitName) {
      return toast.error("Digite uma Unidade");
    }

    await handlePostUnit(customerId, unitName);
    await props.reloadTable();
    props.close();
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.close}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Unidade de Negócio</DialogTitle>
      <DialogContent>
        <TextField
          onChange={(e) => handleSetUnitName(e.target.value)}
          required
          autoFocus
          margin="dense"
          id="name"
          label="Nome da Unidade"
          type="text"
          fullWidth
        />
      </DialogContent>
      <DialogActions className={classes.divFlex}>
        <Button
          onClick={props.close}
          color="primary"
          autoFocus
          className={classes.cancelButtonCreateDialog}
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button
          onClick={handleCreateUnit}
          color="primary"
          className={classes.saveButtonCreateDialog}
          variant="contained"
          autoFocus
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomerDialog;
